import styled from '@emotion/styled'

import { BodyM } from '@/components/Typography'
import { sanitize } from '@/core/utils/security'

import Icon from './Icon'

interface LinkProps {
  source: string
}

const LinkStyles = styled.a({
  marginTop: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

const Link = ({ source }: LinkProps) => (
  <LinkStyles as="a" href={sanitize(source)} target="_blank">
    <BodyM tag="span" color="accent" className="agency-link" emphasys>
      Ver no mapa
    </BodyM>
    <Icon />
  </LinkStyles>
)

export default Link
